import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { PointStoreCartService } from './point-store-cart.service';
import { PointStoreProductOrderService } from './point-store-product-order.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Injectable({
  providedIn: 'root'
})
export class ShoppingCartService {

  shoppingCartObj: any = {
    currentUserProfile: null,
    currentUserAttributes: null,
    currentUserAllAttributes: null,
    fullGammificationProfile: null,
    categoryCollection: {
      rawCategoriesData: null,
      categories: {},
    },
    companyId: 0,
    pointStoreProductValidation: {},
    showCheckOutError: false,
    pointStoreProducts: null,
    pointStoreCart: {
      pointStoreProducts: [],
      pointStoreCartTotal: 0,
    },
    pointStoreLastAddedProduct: null,
    pointStoreDetailedViewProduct: null,
    pointStoreQuantityCartItems: 0,
    pointStorePriceFilters: [
      { label: "All", val: 0, lowerLimit: 0, higherLimit: 999999 },
      { label: "0-14", val: 1, lowerLimit: 0, higherLimit: 14 },
      { label: "15-24", val: 2, lowerLimit: 15, higherLimit: 24 },
      { label: "25-49", val: 3, lowerLimit: 25, higherLimit: 49 },
      { label: "50-74", val: 4, lowerLimit: 50, higherLimit: 74 },
      { label: "75-99", val: 5, lowerLimit: 75, higherLimit: 99 },
      { label: "100-149", val: 6, lowerLimit: 100, higherLimit: 149 },
      { label: "150-199", val: 7, lowerLimit: 150, higherLimit: 199 },
      { label: "200-499", val: 8, lowerLimit: 200, higherLimit: 499 },
      { label: "500-999", val: 9, lowerLimit: 500, higherLimit: 999 },
      { label: "1000+", val: 10, lowerLimit: 1000, higherLimit: 999999 },
    ],
    pointStoreProductFiltered: null,
    pointStoreProductCarousel: null,
    pointStoreProductCarouselItems: [],
    pointStoreProductFeatured: [],
    pointStoreCheckOutInProcess: false,
    pointStoreCheckOutSuccesful: true,
    pointStoreVisibleContent: {
      showLandingPage: true,
      showProductSectionLanding: true,
      showProductSectionFiltered: false,
      showOrdersPage: false,
      showShoppingCartPage: false,
      showPopUpDetails: false,
      showPopUpAddedCart: false,
      showPopUpBackground: false,
      showCheckoutMessage: false,
      showShoppingCart: true,
    },
    pointStoreWishListItems: [],
    categoryCollectionArray: [],
    shoppingCartProducts: [],
    shoppingCartWishlistProducts: [],
    ShoppingCartActiveFilters: [],
    shoppingCartFilter: '',
    shoppingCartActivecategoriesFitler: [],
    shoppingCartCategoryFilter: '',
    shoppingCartOptions: {
      onSaleFilterChecked: false,
      bestSellerFilterChecked: false,
      selectedSubCategories: []
    },
    shoppingCartActiveTab: '',
    shoppingCartSelectedTags: [],
    shoppingCartLandingSortBy: '',
    shoppingCartShowLoader: false,
    shoppingCartIsProductSelected: false,
    shoppingCartIsQtyInputEmpty: false,
    shoppingCartIsCheckingQty: false,
    shoppingCartwasCartUpdated: false, 
    shoppingDisableCheckout: false,
  }

  dateStart: any = null;
  dateEnd: any = null;

  constructor(
    private cvLocalizationService: CVLocalizationService,
    private cvApiService?: CVApiService,
    private pointStoreProductOrderService?: PointStoreProductOrderService,
    private pointStoreCartService?: PointStoreCartService,
    private dialogService?: CvCustomDialogService,
    private cvConfigurationService?: CvConfigurationService,
  ) { 
    this.cvLocalizationService.GetSection("MarketPlace");
  }

  setWishlistItems() {
    let found = null;
    this.shoppingCartObj.shoppingCartWishlistProducts = [];
    this.shoppingCartObj.shoppingCartProducts.forEach(product => {
      found = this.shoppingCartObj.pointStoreWishListItems.find(p => p.ProductID == product.PointStoreProductID);
      if (found != undefined)
        this.shoppingCartObj.shoppingCartWishlistProducts.push(product)
    });
  }

  async getLandingInfo() {
    try {
      await this.getPointStoreProducts();
      this.shoppingCartObj.shoppingCartProducts = JSON.parse(JSON.stringify(this.shoppingCartObj.pointStoreProducts));
      this.shoppingCartObj.shoppingCartProducts.forEach(product => {
        product.showItem = true;
      });
      this.setWishlistItems();
      this.shoppingCartObj.shoppingCartOptions = {
        onSaleFilterChecked: false,
        bestSellerFilterChecked: false,
        selectedSubCategories: []
      }
    } catch (error) {
      showErrorMessage("Error Loading Products WS Object: " + error.message);
    }
  }

  async getUserLoginProfile() {
    try {
      const url = "/api/v2/marketplace/products/users/";
      let response = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        this.shoppingCartObj.currentUserProfile = response.data;
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage(error.message);
    }
  }

  async getWishlistItems() {
    try {
      /*Wishlist items*/
      let url = "/api/v2/marketplace/products/wishlist/";
      let response: any = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        this.shoppingCartObj.pointStoreWishListItems = JSON.parse(JSON.stringify(response.data.filter((i) => { return i.Active && (i.ProductStart == null || new Date(i.ProductStart) <= new Date()) && (i.ProductEnd == null || new Date(i.ProductEnd).addDays(1) > new Date()) })));
        this.setWishlistItems();
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Wishlist Items Object: " + error.message);
    }
  }

  async addWishlistItemWS(product) {
    try {
      const url = "/api/v2/marketplace/products/addwishlist/" + product.PointStoreProductID + "/";
      let response = await this.cvApiService.post(url);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage(error.message);
    }
  }

  async removeWishlistItemWS(product) {
    try {
      const url = "/api/v2/marketplace/products/removewishlist/" + product.PointStoreProductID + "/";
      let response = await this.cvApiService.post(url);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage(error.message);
    }
  }

  async checkProductExistenciesWS(product, isAdding, requestedQty) {
    try {
      const url = "/api/v2/marketplace/products/existencies/" + product.ProductID + "/" + product.Quantity + "/" + product.Variation + "/" + isAdding + "/" + requestedQty + "/";
      let response = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      if(this.cvConfigurationService.isCxOne){
        this.dialogService.showDialog(
          'Warning',
          "Error in checking existencies for product: " + (error.message ?? error.Message),
          1,
          '',
          'Ok',
          true,
          () => { },
          () => { }
        );
      } else {
        showErrorMessage("Error in checking existencies for product: " + (error.message ?? error.Message));
      }
    }
  }

  async updateSessionCartProductQuantityWS(product) {
    try {
      const url = "/api/v2/marketplace/cart/update/";
      let response = await this.cvApiService.post(url, product);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Updating Session Product Cart WS Object: " + error.message);
    }
  }

  async updateQuantity(product) {
    // // $("#upgLoad").show();
    if (product.Quantity != null && product.Quantity != "") {
      await this.updateSessionCartProductQuantityWS(product).then(
        async (result) => {
          await this.getSessionCart();
          // $("#upgLoad").hide();
          await this.getLandingInfo().then((data) => {
            return result;
          });
          // await this.getPointStoreProducts().then((data) => {
          //   return result;
          // });
        });
    }
  }

  async getSessionCart() {
    try {
      const url = "/api/v2/marketplace/orders/products/";
      let response = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        if (response.data != null) {
          this.shoppingCartObj.pointStoreCart.pointStoreProducts = response.data;
          if (this.shoppingCartObj.pointStoreLastAddedProduct != null) {
            let lastAddedProductID = this.shoppingCartObj.pointStoreLastAddedProduct.PointStoreProductID;
            let lastAddedProductVariation = this.shoppingCartObj.pointStoreLastAddedProduct.SelectedVariation != null ? this.shoppingCartObj.pointStoreLastAddedProduct.SelectedVariation : 0;
            let itemIndex = this.shoppingCartObj.pointStoreCart.pointStoreProducts.findIndex(item => item.ProductID == lastAddedProductID && item.Variation == lastAddedProductVariation);
            if (itemIndex > -1)
              this.shoppingCartObj.pointStoreCart.pointStoreProducts.splice(0, 0, this.shoppingCartObj.pointStoreCart.pointStoreProducts.splice(itemIndex, 1)[0]);
          }

          //Find and set the original price on each object. Re-set the title for the session-stored object.
          //  Needs to be done upon sessionCart retrieval, otherwise no original price will be available for session-stored cart items.
          let key = 0;
          for (const product of this.shoppingCartObj.pointStoreCart.pointStoreProducts) {
            if (this.shoppingCartObj.pointStoreProducts != null) {
              var matched = this.shoppingCartObj.pointStoreProducts.filter(function (item) {
                return product.ProductID == item.PointStoreProductID;
              });

              if (matched == null || matched.length < 1) return;
              this.shoppingCartObj.pointStoreCart.pointStoreProducts[key].RegularPrice = matched[0].Price;
              this.shoppingCartObj.pointStoreCart.pointStoreProducts[key].Title = matched[0].Title;
            }
            key++;
          }
        }
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Session WS Object: " + error.message);
    }
  }

  async getFullLogin() {
    try {
      const url = "/api/v2/marketplace/user/profile/";
      let response = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        this.shoppingCartObj.fullGammificationProfile = JSON.parse(JSON.stringify(response.data));
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage(error.message);
    }
  }

  async getAttributesInfo() {
    try {
      //Get the attributes per login
      let url = "/api/v2/marketplace/user/attributes/";
      let response: any = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        this.shoppingCartObj.currentUserAttributes = response.data;
      }
      else {
        throw response;
      }

      //Get all the attributes available
      url = "../api/v1/GetAgentAttributesByGroup/0?isFromPointStore=1";
      response = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        this.shoppingCartObj.companyId = response.data.CompanyID;
        this.shoppingCartObj.currentUserAllAttributes = response.data.attributes;
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Attribute Info: " + error.message);
    }
  }

  async checkoutShoppingCart() {
    // // $("#upgLoad").show();
    this.shoppingCartObj.pointStoreCheckOutInProcess = true;
    let hasErrorValidation = [];
    try {
      //Replaced foreach statement with for statement
      // we have to wait for the function checkProductExistenciesWS
      //replaced productCart.ProductID with the value of the function this.GetProductCartId(productCart), we have products with variations
      for (let product of this.shoppingCartObj.pointStoreProducts) {
        for (let productCart of this.shoppingCartObj.pointStoreCart.pointStoreProducts) {
          if (product.PointStoreProductID == productCart.ProductID) {
            let response: any = await this.checkProductExistenciesWS(productCart, false, 0);
            let productID = this.GetProductCartId(productCart);

            if (response) {
              this.shoppingCartObj.pointStoreProductValidation[productID] = false;
            } else {
              this.shoppingCartObj.pointStoreProductValidation[productID] = true;
            }
            hasErrorValidation.push(this.shoppingCartObj.pointStoreProductValidation[productID]);
          }
        }
      }

      var totalCart = this.getCartTotal();
      if (hasErrorValidation.indexOf(true) === -1) {
        let products = this.shoppingCartObj.pointStoreCart.pointStoreProducts;
        const url = "/api/v2/marketplace/products/checkout/" + totalCart + "/";
        let response = await this.cvApiService.post(url, products);
        if (response.status_code == 200) {
          await this.getFullLogin();
          // this.getPointStoreProducts();
          await this.getLandingInfo();
          if (response.data) {
            this.shoppingCartObj.pointStoreVisibleContent.showCheckoutMessage = true;
            this.shoppingCartObj.pointStoreCart.pointStoreProducts = [];
            if(!this.cvConfigurationService.isCxOne){
              await this.pointStoreProductOrderService.LoadPointStoreProductHistoryOrders(); /***check this one*/
            }
            this.shoppingCartObj.showCheckOutError = false;
          } else {
            this.shoppingCartObj.showCheckOutError = true; //The server is currently only returning true/false for the checkout process. False generally indicates an error with item quantity or the item no longer exists.
          }
          // $("#upgLoad").hide();
          this.shoppingCartObj.pointStoreCheckOutInProcess = false;
          return response.data;
        }
        else {
          throw response;
        }
      } else {
        // $("#upgLoad").hide();
        this.shoppingCartObj.pointStoreCheckOutInProcess = false;
        return false;
      }
    } catch (error) {
      showErrorMessage(error.message);
    }
  }

  async checkShoppingCartProductExistencies(product, isAdding = false, requestedQty = 0) {
    this.checkProductExistenciesWS(product, isAdding, requestedQty).then((result) => {
      return result;
    });
  }

  async getPointStoreProducts() {
    try {
      /*Wishlist items*/
      await this.getWishlistItems();

      /*Load products info*/
      let url = "/api/v2/marketplace/products/";
      let response = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        this.shoppingCartObj.pointStoreProducts = JSON.parse(JSON.stringify(response.data));
        this.shoppingCartObj.categoryCollectionArray = [];

        let TotalSoldProducts = 0;

        this.shoppingCartObj.pointStoreProducts.sort(function (a, b) {
          return b.SoldProducts - a.SoldProducts;
        });        
        
        this.shoppingCartObj.pointStoreProducts.forEach((product, index) => {
          product.RegularPrice = product.Price;
          product.CalculatedRealPrice = product.Price;
          product.isBestSeller = false;
          product.isInWhisList = false;
          product.requiredAttributes = [];
          product.isLocked = false;
          var is_current_sale = this.filterCollectionsByType(product, 1);
          if (is_current_sale) {
            if (product.Sale != null && product.Sale != 0) {
              product.CalculatedRealPrice = Math.ceil(product.Price - (product.Price * product.Sale / 100));
            }
          }
          /*
           * This attemp to get the list of attributes that are not achived by the current user
           * so that we can display as a reason why the marketplace item appeared locked
           * */

          if (product.PointStoreProductAllAssignments.attr.length > 0) {
            // This code gets all the required attributes just in case logic swtich back to make required every single attribute of the product
            product.isLocked = product.PointStoreProductAllAssignments.attr.filter((attribute) => {
              return this.shoppingCartObj.currentUserAttributes.some(function (agentAttribute) {
                return agentAttribute.AgentAttributeID == attribute.AgentAttributeID && agentAttribute.AgentAttributeValueID == attribute.AttributeValueID
              });
            }).length == 0;
          }

          if (product.SoldProducts > 0) TotalSoldProducts++;

          product.isInWhisList = this.shoppingCartObj.pointStoreWishListItems.filter(function (item) { return item.ProductID == product.PointStoreProductID }).length > 0

          var exists = 0;
          // ----- Original (pre-arrayitization) Categories + Subcategories -----
          //  Leaving this implemented for anything else in the market that may reference this.
          if (typeof this.shoppingCartObj.categoryCollection.categories[product.Category] === 'undefined') {
            this.shoppingCartObj.categoryCollection.categories[product.Category] = [product.SubCategory];
          }

          if (this.shoppingCartObj.categoryCollection.categories[product.Category]) {
            if (this.shoppingCartObj.categoryCollection.categories[product.Category].indexOf(product.SubCategory) < 0) {
              this.shoppingCartObj.categoryCollection.categories[product.Category].push(product.SubCategory);
            }
          }
          // ----- New (arrayitized) Categories + Subcategories -----
          //Filter the category collection, retrieving only those that match the category name. (Beginning of checking if the category is already in the array.)
          var matchedCategoryObject = this.shoppingCartObj.categoryCollectionArray.filter(function (c) {
            return c.name == product.Category;
          });

          //If such a category already exists, it'll be in the returned filter array, resulting in length > 0 (true).
          //  If the category is already in the array, find the matching object and append the subcategory to its list.
          //  Otherwise, create a new category object, add its subcategory and then push it to the collection.
          if (matchedCategoryObject.length > 0) {
            //Check for duplicates
            if ((matchedCategoryObject[0].subcategories.indexOf(product.SubCategory) > -1) == false) //indexOf(...) for IE11 lifesupport.
              matchedCategoryObject[0].subcategories.push(product.SubCategory);
          } else {
            var newCategoryObject = {
              name: product.Category,
              subcategories: []
            };
            newCategoryObject.subcategories.push(product.SubCategory);

            this.shoppingCartObj.categoryCollectionArray.push(newCategoryObject);
          }
        });

        var TotalTopSellerProducts = Math.round(TotalSoldProducts * 0.20) < 50 ? Math.round(TotalSoldProducts * 0.20) : 50;

        for (let i = 0; i < TotalTopSellerProducts; i++) {
          this.shoppingCartObj.pointStoreProducts[i].isBestSeller = true;
        }

        //Sort the category array by category name.
        this.shoppingCartObj.categoryCollectionArray.sort((a, b) => {
          return a.name > b.name;
        });

        this.shoppingCartObj.categoryCollectionArray.forEach(function (a) {
          a.subcategories.sort(); //Simple array of text objects, shouldn't need anything stupid like category names.
        });

        this.shoppingCartObj.pointStoreProducts.sort(function () {
          return Math.round(Math.random()) - 0.5;
        });

        this.getFeaturedItems();
        this.getCarouselItems();
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Products WS Object: " + error.message);
    }
  }

  async deleteItemFromCart(product) {
    let ItemQuantity = 0;
    let ItemPosistion = null;
    let productWasFound = false;
    if (this.shoppingCartObj.pointStoreCart.pointStoreProducts.length > 0) {
      let key = 0;
      for (let productCart of this.shoppingCartObj.pointStoreCart.pointStoreProducts) {
        if (product.ProductID == productCart.ProductID) {
          if (product.Variation != null && product.Variation > 0) {
            if (product.Variation == productCart.Variation){
              ItemPosistion = key;
              productWasFound = true;
            }              
          } else {
            ItemPosistion = key;
            productWasFound = true;
          }            
        }
        key++;
      }
    }
    if(productWasFound){
      this.shoppingCartObj.pointStoreCart.pointStoreProducts.splice(ItemPosistion, 1);
      try {
        let response = await this.saveSessionCartWS();
        if (response.status_code == 200) {
          await this.getLandingInfo();
          return response;
        }
        else {
          throw response;
        }
      } catch (error) {
        if (this.cvConfigurationService.isCxOne) {
          this.dialogService.showDialog(
            'Warning',
            error.message,
            1,
            '',
            'Ok',
            true,
            () => { },
            () => { }
          );
        } else {
          showErrorMessage(error.message);
        }
      }
    }

  }

  async saveSessionCartWS() {
    let products = this.shoppingCartObj.pointStoreCart.pointStoreProducts;
    try {
      const url = "/api/v2/marketplace/cart/session/";
      let response = await this.cvApiService.post(url, products);
      if (response.status_code == 200) {
        await this.getSessionCart();
        return response;
      }
      else {
        throw response;
      }
    } catch (error) {
      if (this.cvConfigurationService.isCxOne) {
        this.dialogService.showDialog(
          'Warning',
          "Error Saving Session Cart WS Object: " + error.message,
          1,
          '',
          'Ok',
          true,
          () => { },
          () => { }
        );
      } else {
        showErrorMessage("Error Saving Session Cart WS Object: " + error.message);
      }
    }
  }

  filterCollectionsByType(item, kind) {
    let currentDate: any = new Date();
    currentDate = currentDate.setHours(0, 0, 0, 0);

    let filterMatch = false;
    switch (kind) {
      case 1:
        this.dateStart = item.SaleStart;
        this.dateEnd = item.SaleEnd;
        break;

      case 2:
        this.dateStart = item.FeatureStart;
        this.dateEnd = item.FeatureEnd;
        break;

      case 3:
        this.dateStart = item.CarouselStart;
        this.dateEnd = item.CarouselEnd;
        break;
    }

    //Defined date range for the product tag
    if (this.dateStart != null && this.dateStart != "" && this.dateEnd != null && this.dateEnd != "") {
      this.dateStart = new Date(this.dateStart);
      this.dateStart = this.dateStart.setHours(0, 0, 0, 0);
      this.dateEnd = new Date(this.dateEnd);
      this.dateEnd = this.dateEnd.setHours(0, 0, 0, 0);

      filterMatch = (this.dateStart <= currentDate && currentDate <= this.dateEnd) ? true : false;
    }

    //Just s start date defined for the product tag
    if (this.dateStart != null && this.dateStart != "" && (this.dateEnd == null || this.dateEnd == "")) {
      this.dateStart = new Date(this.dateStart);
      this.dateStart = this.dateStart.setHours(0, 0, 0, 0);

      filterMatch = this.dateStart <= currentDate ? true : false;
    }

    //No dates defined for product tag
    if ((this.dateStart == null || this.dateStart == "") && (this.dateEnd == null || this.dateEnd == "")) {
      filterMatch = false;
    }

    if (filterMatch && kind == 1 && item.HasProductVariations && item.VariationsData.length > 0) {
      let variationOnSale = item.VariationsData.find(variation => variation.Active && variation.VariationOnSale);
      if (variationOnSale == null)
        filterMatch = false;
    }

    return filterMatch;
  }

  getFeaturedItems() {
    this.shoppingCartObj.pointStoreProductFeatured.length = 0;

    if (this.shoppingCartObj.pointStoreProducts != null) {
      for (var i = 0; i < this.shoppingCartObj.pointStoreProducts.length; i++) {
        // If the product is a featured product, add it to the featured product array.
        if (this.filterCollectionsByType(this.shoppingCartObj.pointStoreProducts[i], 2)) {
          this.shoppingCartObj.pointStoreProductFeatured.push(this.shoppingCartObj.pointStoreProducts[i]);
        }
      }

      // If there are fewer than four featured products, populate the featured product array with random products.                
      var failsafe = 100; //Prevent an edge case infinite loop
      while (this.shoppingCartObj.pointStoreProductFeatured.length < 4 && this.shoppingCartObj.pointStoreProducts[0] != null) {
        // Choose a random product
        var randomItem = this.shoppingCartObj.pointStoreProducts[
          Math.floor(Math.random() * this.shoppingCartObj.pointStoreProducts.length)
        ];

        // If the random product does not already exist in the featured array, add it to the featured array.
        if ($.inArray(randomItem, this.shoppingCartObj.pointStoreProductFeatured) == -1)
          this.shoppingCartObj.pointStoreProductFeatured.push(randomItem);

        //Decrement the failsafe counter. If the counter reaches zero, break out of the loop
        failsafe--;
        if (failsafe <= 0)
          break;

        //Get the products that are remaining. If there are no more products left to add to the featured list, break out of the while loop.
        var remainingProducts = this.shoppingCartObj.pointStoreProducts.filter((itm) => { return this.shoppingCartObj.pointStoreProductFeatured.indexOf(itm) < 0; });
        if (remainingProducts == null || remainingProducts.length <= 0)
          break;
      }
    }
  }

  getCarouselItems() {
    //Verify that the marketplace items are actually loaded.
    if (this.shoppingCartObj.pointStoreProducts == null)
      return;

    //Date to compare to.
    var Today = new Date();

    this.shoppingCartObj.pointStoreProductCarouselItems = this.shoppingCartObj.pointStoreProducts.filter(p => 
      //If the item is marked as carousel, carousel functionality is enabled (checked) and is at or between the active dates (if a start or end date is set), include it.
        (p.Active && this.filterCollectionsByType(p, 3))
    );

    if (this.shoppingCartObj.pointStoreProductCarouselItems.length == 0) {
      // populate the carousel product array with random products.
      var failsafe = 100; //Prevent an edge case infinite loop
      while (this.shoppingCartObj.pointStoreProductCarouselItems.length < 4 && this.shoppingCartObj.pointStoreProducts[0] != null) {
        // Choose a random product
        let randomItem = this.shoppingCartObj.pointStoreProducts[
          Math.floor(Math.random() * this.shoppingCartObj.pointStoreProducts.length)
        ];

        // If the random product does not already exist in the carousel array, add it to the carousel array.
        if ($.inArray(randomItem, this.shoppingCartObj.pointStoreProductCarouselItems) == -1)
          this.shoppingCartObj.pointStoreProductCarouselItems.push(randomItem);

        //Decrement the failsafe counter. If the counter reaches zero, break out of the loop
        failsafe--;
        if (failsafe <= 0)
          break;

        //Get the products that are remaining. If there are no more products left to add to the carousel list, break out of the while loop.
        let remainingProducts = this.shoppingCartObj.pointStoreProducts.filter((itm) => { return this.shoppingCartObj.pointStoreProductCarouselItems.indexOf(itm) < 0; });
        if (remainingProducts == null || remainingProducts.length <= 0)
          break;
      }
    }
  }

  getCartTotal() {
    let total = 0;
    this.shoppingCartObj.pointStoreCart.pointStoreProducts.forEach((product, key) => {
      let itemTotal = product.CalculatedRealPrice * product.Quantity;
      total += itemTotal;
    });
    return total;
  }

  filterShoppingCartProduct(filters: String[] = [], category, subCategoryFilter = [], isReset = false) {
    if (isReset) {
      this.shoppingCartObj.shoppingCartProducts.forEach(product => {
        product.showItem = true;
      });
    }
    this.shoppingCartObj.ShoppingCartActiveFilters = filters;
    this.shoppingCartObj.shoppingCartActivecategoriesFitler = subCategoryFilter;
    filters.forEach(filter => {
      switch (filter) {
        case 'OnSale':
          this.shoppingCartObj.shoppingCartProducts.forEach(product => {
            if (!(product.Sale && this.filterCollectionsByType(product, 1))) {
              product.showItem = false;
            }
          });
          break;
        case 'BestSeller':
          this.shoppingCartObj.shoppingCartProducts.forEach(product => {
            if (!product.isBestSeller) {
              product.showItem = false;
            }
          });
          break;
        case 'Category':
          this.filterShoppingCartProductByCategory(category);
          break;
        case 'SubCategory':
          this.filterShoppingCartProductBySubCategory(subCategoryFilter);
          break;
        default:
          return;
      }
    });
    if (isReset)
      this.filterShoppingCartProductByLabel(false);
  }

  filterShoppingCartProductByCategory(category) {
    this.shoppingCartObj.shoppingCartCategoryFilter = category;
    this.shoppingCartObj.shoppingCartProducts.forEach(product => {
      if (product.Category != category)
        product.showItem = false;
    });
  }

  filterShoppingCartProductBySubCategory(subCategoryFilter) {
    this.shoppingCartObj.shoppingCartProducts.forEach(product => {
      let isFound = subCategoryFilter.some(element => {
        if (element.Category === product.Category && element.Subcategory === product.SubCategory) {
          return true;
        }
        return false;
      });
      if (!isFound)
        product.showItem = false;
    });
  }

  filterShoppingCartProductByLabel(isReset: boolean) {
    if (isReset) {
      this.shoppingCartObj.shoppingCartProducts.forEach(product => {
        product.showItem = true;
      });
    }
    if (this.shoppingCartObj.shoppingCartFilter != null && this.shoppingCartObj.shoppingCartFilter != '') {
      this.shoppingCartObj.shoppingCartProducts.forEach(product => {
        if (!product.Title.toUpperCase().includes(this.shoppingCartObj.shoppingCartFilter.toUpperCase())) {
          product.showItem = false;
        }
      });
    }
    if (isReset)
      this.filterShoppingCartProduct(this.shoppingCartObj.ShoppingCartActiveFilters, this.shoppingCartObj.shoppingCartCategoryFilter, this.shoppingCartObj.shoppingCartActivecategoriesFitler);
  }

  clearShoppingCartProductFilters() {
    this.shoppingCartObj.ShoppingCartActiveFilters = [];
    this.shoppingCartObj.shoppingCartActivecategoriesFitler = [];
    this.shoppingCartObj.shoppingCartProducts.forEach(product => {
      product.showItem = true;
    });
    this.filterShoppingCartProductByLabel(false);
  }

  filterProducts(item, filterMatchProduct, searchBy): boolean {
    let match = false;
    if (filterMatchProduct != '' && !searchBy[0].chk && !searchBy[1].chk && !searchBy[2].chk && !searchBy[3].chk) {
      match = this.matchProductByTitle(item, filterMatchProduct);
    } else {
      if (searchBy[2].chk) {
        match = this.matchProductByCategoryOrSubcategory(item, 2, searchBy, filterMatchProduct)
      }
      if (searchBy[3].chk) {
        match = this.matchProductByCategoryOrSubcategory(item, 3, searchBy, filterMatchProduct)
      }
      if (searchBy[4].chk) {
        match = item.isInWhisList;
      }
      if (searchBy[5].chk) {
        match = item.isBestSeller;
      }
    }
    return match;
  }

  matchProductByCategoryOrSubcategory(item, kind, searchBy, filterMatchProduct) {
    let matchSearchString = filterMatchProduct != '' ? this.matchProductByTitle(item, filterMatchProduct) : true;
    let matchFilters = false;

    if (kind == 2) {
      matchFilters = this.matchByCategory(item, searchBy);
    } else {
      if (searchBy[3].val != null && searchBy[3].val.length > 0) {
        matchFilters = this.matchBySubCategory(item, searchBy);
      } else if (searchBy[2].val != "" && !searchBy[2].chk) {
        matchFilters = this.matchByCategory(item, searchBy);
      }
    }
    return (matchFilters && matchSearchString);
  }

  matchByCategory(item, searchBy) {
    let matchFilters = false;
    if (item.Category == searchBy[2].val || searchBy[2].val == 'All') {
      if (searchBy[1].chk) {
        if (searchBy[0].chk) {
          matchFilters = this.searchByPriceRange(item, searchBy);
        } else {
          matchFilters = this.filterCollectionsByType(item, 1);
        }
      } else {
        if (searchBy[0].chk) {
          matchFilters = this.searchByPriceRange(item, searchBy);
        } else {
          matchFilters = true;
        }
      }
    }
    return matchFilters;
  }

  matchBySubCategory(item, searchBy) {
    let matchFilters = false;
    searchBy[3].val.forEach((value, key) => {
      if (item.SubCategory == value && item.Category == searchBy[2].val) {
        if (searchBy[1].chk) {
          if (searchBy[0].chk) {
            matchFilters = this.searchByPriceRange(item, searchBy);
          } else {
            matchFilters = this.filterCollectionsByType(item, 1);
          }
        } else {
          if (searchBy[0].chk) {
            matchFilters = this.searchByPriceRange(item, searchBy);
          } else {
            matchFilters = true;
          }
        }
      }
    });
    return matchFilters;
  }

  searchByPriceRange(item, searchBy) {
    let filterStatus = false;
    if (searchBy[0].val != null && searchBy[0].val.length > 0) {
      searchBy[0].val.forEach((value, key) => {
        if ((item.CalculatedRealPrice >= this.shoppingCartObj.pointStorePriceFilters[value].lowerLimit) && (item.CalculatedRealPrice <= this.shoppingCartObj.pointStorePriceFilters[value].higherLimit)) {
          filterStatus = searchBy[1].chk ? this.filterCollectionsByType(item, 1) : true;
        }
      });
    } else {
      filterStatus = searchBy[1].chk ? this.filterCollectionsByType(item, 1) : true;
    }

    return filterStatus;
  }

  matchProductByTitle(item, filterMatchProduct) {
    let match_filter = false;

    if (filterMatchProduct != '') {
      if (item.Title.toLowerCase().indexOf(filterMatchProduct.toLowerCase()) > -1) {
        match_filter = true;
      }
    }

    if (filterMatchProduct == '') {
      match_filter = true;
    }

    return match_filter;
  }

  countDisplayCategoriesBySearch(category) {
    let quantityCount = 0;
    if (this.shoppingCartObj.pointStoreProductFiltered != null && this.shoppingCartObj.pointStoreProductFiltered.length > 0) {
      this.shoppingCartObj.pointStoreProductFiltered.forEach((product, key) => {
        if (product.Category == category) quantityCount = quantityCount + 1;
      });
    }
    return quantityCount;
  }

  getCurrentCartQuantity() {
    let total = 0;
    for (const product of this.shoppingCartObj.pointStoreCart.pointStoreProducts) {
      const productQty = parseInt(product.Quantity);
      total += productQty;
    }
    return total;
  }

  sortProductOrder(sorting): any {
    let sortingBy = null;
    switch (sorting) {
      case "PriceLowToHigh":
        sortingBy = 'Price';
        break;
      case "PriceHighToLow":
        sortingBy = '-Price';
        break;
      case "TitleAToZ":
        sortingBy = 'Title';
        break;
      case "TitleZToA":
        sortingBy = '-Title';
        break;
    }
    return sortingBy;
  }

  async removeWishlistItem(product) {
    this.shoppingCartObj.shoppingCartShowLoader = true;
    try {
      await this.removeWishlistItemWS(product);
      await this.getWishlistItems();
      let carouselProductIndex = this.shoppingCartObj.pointStoreProductCarouselItems.findIndex((p) => { return p.PointStoreProductID === product.PointStoreProductID; });
      if (carouselProductIndex > -1)
        this.shoppingCartObj.pointStoreProductCarouselItems[carouselProductIndex].isInWhisList = false;
      let productIndex = this.shoppingCartObj.shoppingCartProducts.findIndex((p) => { return p.PointStoreProductID === product.PointStoreProductID; });
      if (productIndex > -1)
        this.shoppingCartObj.shoppingCartProducts[productIndex].isInWhisList = false;
      let featuredProductIndex = this.shoppingCartObj.pointStoreProductFeatured.findIndex((p) => { return p.PointStoreProductID === product.PointStoreProductID; });
      if (featuredProductIndex > -1)
        this.shoppingCartObj.pointStoreProductFeatured[featuredProductIndex].isInWhisList = false;


      this.shoppingCartObj.shoppingCartShowLoader = false;
      return true;
    } catch (error) {
      this.shoppingCartObj.shoppingCartShowLoader = false;
      showErrorMessage("Error removing item to wishlist Object: " + error.message);
      return false;
    }
  }

  async addWishlistItem(product) {
    this.shoppingCartObj.shoppingCartShowLoader = true;
    try {
      await this.addWishlistItemWS(product);
      await this.getWishlistItems();
      let carouselProductIndex = this.shoppingCartObj.pointStoreProductCarouselItems.findIndex((p) => { return p.PointStoreProductID === product.PointStoreProductID; });
      if (carouselProductIndex > -1)
        this.shoppingCartObj.pointStoreProductCarouselItems[carouselProductIndex].isInWhisList = true;
      let productIndex = this.shoppingCartObj.shoppingCartProducts.findIndex((p) => { return p.PointStoreProductID === product.PointStoreProductID; });
      if (productIndex > -1)
        this.shoppingCartObj.shoppingCartProducts[productIndex].isInWhisList = true;
      let featuredProductIndex = this.shoppingCartObj.pointStoreProductFeatured.findIndex((p) => { return p.PointStoreProductID === product.PointStoreProductID; });
      if (featuredProductIndex > -1)
        this.shoppingCartObj.pointStoreProductFeatured[featuredProductIndex].isInWhisList = true;
      this.shoppingCartObj.shoppingCartShowLoader = false;
      return true;
    } catch (error) {
      this.shoppingCartObj.shoppingCartShowLoader = false;
      showErrorMessage("Error adding item to wishlist Object: " + error.message);
      return false;
    }
  }

  async addProductsToCart(product, quantity, variation = null) {
    let exitstsInCart = false;
    let existingItemPos = null;
    let length = 0;
    let productTotal, productCosts = 0;
    let isValid = true;
    let selectedVariation;
    let selectedRealPrice = product.CalculatedRealPrice;
    let originalPrice = 0;

    if (!product.HasProductVariations) {
      variation = null;
    }

    if (product.HasVariationPrices) {
      selectedVariation = product.VariationsData.find((v) => { return v.PointStoreProductVariationID == variation; });
      if (selectedVariation != null) {
        if (selectedVariation.VariationOnSale) {
          selectedRealPrice = Math.ceil(selectedVariation.VariationPrice * ((100 - product.Sale) / 100));
        } else
          selectedRealPrice = selectedVariation.VariationPrice;
      }
      //Is the price without discount that is defined in the variant
      originalPrice = selectedVariation.VariationPrice;
    }else if(product.HasProductVariations && !product.HasVariationPrices){
      /**
       * If HasVariationPrices is false, the product has variations without different prices and some have discount.
       */
      selectedVariation = product.VariationsData?.find((v) => { return v.PointStoreProductVariationID == variation; });
      if (selectedVariation) {
        /**
         * If onSale is false, then the price will be set to not discounted.
         */
        if (!selectedVariation.VariationOnSale) {
          selectedRealPrice = product.Price;
        }
        //The price is the product.CalculatedRealPrice if onSale is true.
      }
      //Is the main price without any discount.
      originalPrice = product.Price
    }

    let cartItem = {
      ProductID: product.PointStoreProductID,
      ProductCost: selectedVariation != undefined ? originalPrice : product.Price,
      CalculatedRealPrice: selectedRealPrice,
      Quantity: quantity,
      Title: product.Title,
      ProductImageID: product.ProductImageID,
      Variation: variation
    };

    return await this.checkProductExistenciesWS(cartItem, true, quantity).then(async (result) => {
      if (result) {
        if (this.shoppingCartObj.pointStoreCart.pointStoreProducts.length > 0) {
            let key = 0;
            for (const productInArray of this.shoppingCartObj.pointStoreCart.pointStoreProducts) {
              if (product.PointStoreProductID == productInArray.ProductID) {
                if (variation != null && variation > 0) {
                  if (productInArray.Variation == cartItem.Variation) {
                    exitstsInCart = true;
                    existingItemPos = key;
                  }
                }
                else {
                  exitstsInCart = true;
                  existingItemPos = key;
                }
              }
              key++;
            }
        }

        if (!exitstsInCart) {
          this.shoppingCartObj.pointStoreCart.pointStoreProducts.unshift(this.pointStoreCartService.createNewProduct());
          this.shoppingCartObj.pointStoreCart.pointStoreProducts[0].ProductID = cartItem.ProductID;
          this.shoppingCartObj.pointStoreCart.pointStoreProducts[0].ProductCost = cartItem.ProductCost;
          this.shoppingCartObj.pointStoreCart.pointStoreProducts[0].CalculatedRealPrice = cartItem.CalculatedRealPrice;
          this.shoppingCartObj.pointStoreCart.pointStoreProducts[0].Quantity = cartItem.Quantity;
          this.shoppingCartObj.pointStoreCart.pointStoreProducts[0].Title = cartItem.Title;
          this.shoppingCartObj.pointStoreCart.pointStoreProducts[0].ProductImageID = cartItem.ProductImageID;
          this.shoppingCartObj.pointStoreCart.pointStoreProducts[0].Variation = cartItem.Variation;
        } else {
          this.shoppingCartObj.pointStoreCart.pointStoreProducts[existingItemPos].Quantity = parseInt(this.shoppingCartObj.pointStoreCart.pointStoreProducts[existingItemPos].Quantity) + parseInt(quantity);
        }

        this.shoppingCartObj.pointStoreLastAddedProduct = product;
        this.shoppingCartObj.pointStoreLastAddedProduct.SelectedVariation = variation;
        // this.saveSessionCartWS().then(() => {
        //   return this.getPointStoreProducts();
        // }).then(() => {
        //   return result;
        // });
        await this.saveSessionCartWS();
        await this.getLandingInfo();
        // await this.getPointStoreProducts();
        return result;

      } else {
        // await this.getPointStoreProducts();
        await this.getLandingInfo();

        if (this.cvConfigurationService.isCxOne) {
          this.dialogService.showDialog(
            this.cvLocalizationService.getCachedText("MarketPlace", "Warning_Text", "Warning"),
            this.cvLocalizationService.getCachedText("MarketPlace", "Not_Enough_Existencies", 'Not enough stock for the requested quantity of this item.'),
            1,
            '',
            this.cvLocalizationService.getCachedText("MarketPlace", "Ok", "Ok"),
            true,
            () => { },
            () => { }
          );
        } else {
          showErrorMessage(this.cvLocalizationService.getCachedText("MarketPlace", "Not_Enough_Existencies", 'Not enough stock for the requested quantity of this item.'));
        }

        return result;

        // this.getPointStoreProducts().then((productsResult) => {
        //   showErrorMessage("Not enough stock for the requested quantity of this item.");
        //   return result;
        // });
      }
    });
  }


  /**
   * This function is used to set the above filter after updating shoppingCartObj.shoppingCartProducts. 
   * @param pf Previous pscs.
   */
  configureCurrentFilter(pf: any): void {
    this.shoppingCartObj.shoppingCartOptions = pf.shoppingCartOptions;
    this.shoppingCartObj.ShoppingCartActiveFilters = pf.ShoppingCartActiveFilters;
    this.shoppingCartObj.shoppingCartCategoryFilter = pf.shoppingCartCategoryFilter;
    this.shoppingCartObj.shoppingCartActivecategoriesFitler = pf.shoppingCartActivecategoriesFitler;
    this.shoppingCartObj.shoppingCartLandingSortBy = pf.shoppingCartLandingSortBy;
    this.shoppingCartObj.shoppingCartFilter = pf.shoppingCartFilter;

    this.filterShoppingCartProductByLabel(true);

    // this.filterShoppingCartProduct(this.shoppingCartObj.ShoppingCartActiveFilters,
    //                                                   this.shoppingCartObj.shoppingCartCategoryFilter,
    //                                                   this.shoppingCartObj.shoppingCartActivecategoriesFitler, true);

    const tempSortByFilter = this.shoppingCartObj.shoppingCartLandingSortBy == '' ? 'PriceLowToHigh' : this.shoppingCartObj.shoppingCartLandingSortBy;

    this.configureCurrentFilterSortBy(tempSortByFilter);
    this.configureCurrentWishlistFiterSortBy(tempSortByFilter);
  }

  /**
 * This function is used to set the sort By filter after updating shoppingCartObj.shoppingCartProducts. 
 * @param sortBy sort by => PriceLowToHigh, PriceHighToLow, etc.
 */
  configureCurrentFilterSortBy(sortBy: any): void {
    switch (sortBy) {
      case "PriceLowToHigh":
      default:
        this.shoppingCartObj.shoppingCartProducts.sort((a, b) => {
          let priceA: any = 0;
          let priceB: any = 0;
          if (a.HasProductVariations && a.HasVariationPrices && a.VariationsData.length) {
            let variationA = a.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * a.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * a.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceA = variationA.VariationOnSale ? Math.ceil(variationA.VariationPrice - (variationA.VariationPrice * a.Sale / 100)) : variationA.VariationPrice;
          }
          else {
            priceA = a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date()) ? Math.ceil(a.Price - (a.Price * a.Sale / 100)) : a.Price;
          }

          if (b.HasProductVariations && b.HasVariationPrices && b.VariationsData.length) {
            let variationB = b.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * b.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * b.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceB = variationB.VariationOnSale ? Math.ceil(variationB.VariationPrice - (variationB.VariationPrice * b.Sale / 100)) : variationB.VariationPrice;
          }
          else {
            priceB = b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(b.SaleEnd) > new Date()) ? Math.ceil(b.Price - (b.Price * b.Sale / 100)) : b.Price;
          }

          return parseFloat(priceA) - parseFloat(priceB);
        });
        break;
      case "PriceHighToLow":
        this.shoppingCartObj.shoppingCartProducts.sort((a, b) => {
          let priceA: any = 0;
          let priceB: any = 0;
          if (a.HasProductVariations && a.HasVariationPrices && a.VariationsData.length) {
            let variationA = a.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * a.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * a.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceA = variationA.VariationOnSale ? Math.ceil(variationA.VariationPrice - (variationA.VariationPrice * a.Sale / 100)) : variationA.VariationPrice;
          }
          else {
            priceA = a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date()) ? Math.ceil(a.Price - (a.Price * a.Sale / 100)) : a.Price;
          }

          if (b.HasProductVariations && b.HasVariationPrices && b.VariationsData.length) {
            let variationB = b.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * b.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * b.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceB = variationB.VariationOnSale ? Math.ceil(variationB.VariationPrice - (variationB.VariationPrice * b.Sale / 100)) : variationB.VariationPrice;
          }
          else {
            priceB = b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(b.SaleEnd) > new Date()) ? Math.ceil(b.Price - (b.Price * b.Sale / 100)) : b.Price;
          }

          return parseFloat(priceB) - parseFloat(priceA);
        });
        break;
      case "TitleAToZ":
        this.shoppingCartObj.shoppingCartProducts.sort((a, b) => a.Title.localeCompare(b.Title));
        break;
      case "TitleZToA":
        this.shoppingCartObj.shoppingCartProducts.sort((a, b) => b.Title.localeCompare(a.Title));
        break;
    }
  }


  /**
* This function is used to set the sort By filter after updating shoppingCartObj.shoppingCartProducts in the wishlist tab. 
* @param sortBy sort by => PriceLowToHigh, PriceHighToLow, etc.
*/
  configureCurrentWishlistFiterSortBy(sortBy: any): void {
    switch (sortBy) {
      case "PriceLowToHigh":
      default:
        this.shoppingCartObj.shoppingCartWishlistProducts.sort((a, b) => {
          let priceA: any = 0;
          let priceB: any = 0;
          if (a.HasProductVariations && a.HasVariationPrices && a.VariationsData.length) {
            let variationA = a.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * a.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * a.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceA = variationA.VariationOnSale ? Math.ceil(variationA.VariationPrice - (variationA.VariationPrice * a.Sale / 100)) : variationA.VariationPrice;
          }
          else {
            priceA = a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date()) ? Math.ceil(a.Price - (a.Price * a.Sale / 100)) : a.Price;
          }

          if (b.HasProductVariations && b.HasVariationPrices && b.VariationsData.length) {
            let variationB = b.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * b.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * b.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceB = variationB.VariationOnSale ? Math.ceil(variationB.VariationPrice - (variationB.VariationPrice * b.Sale / 100)) : variationB.VariationPrice;
          }
          else {
            priceB = b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(b.SaleEnd) > new Date()) ? Math.ceil(b.Price - (b.Price * b.Sale / 100)) : b.Price;
          }

          return parseFloat(priceA) - parseFloat(priceB);
        });
        break;
      case "PriceHighToLow":
        this.shoppingCartObj.shoppingCartWishlistProducts.sort((a, b) => {
          let priceA: any = 0;
          let priceB: any = 0;
          if (a.HasProductVariations && a.HasVariationPrices && a.VariationsData.length) {
            let variationA = a.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * a.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * a.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceA = variationA.VariationOnSale ? Math.ceil(variationA.VariationPrice - (variationA.VariationPrice * a.Sale / 100)) : variationA.VariationPrice;
          }
          else {
            priceA = a.IsOnSaleChecked && a.Sale > 0 && (a.SaleEnd == null || new Date(a.SaleEnd) > new Date()) ? Math.ceil(a.Price - (a.Price * a.Sale / 100)) : a.Price;
          }

          if (b.HasProductVariations && b.HasVariationPrices && b.VariationsData.length) {
            let variationB = b.VariationsData.reduce((prev, curr) => {
              let variationPriceA = prev.VariationPrice;
              let variationPriceB = curr.VariationPrice;
              if (b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(a.SaleEnd) > new Date())) {
                if (prev.VariationOnSale) {
                  variationPriceA = Math.ceil(prev.VariationPrice - (prev.VariationPrice * b.Sale / 100));
                } else
                  variationPriceA = prev.VariationPrice;
                if (curr.VariationOnSale) {
                  variationPriceB = Math.ceil(curr.VariationPrice - (curr.VariationPrice * b.Sale / 100));
                } else
                  variationPriceB = curr.VariationPrice;
              }
              return variationPriceA < variationPriceB ? prev : curr
            });
            priceB = variationB.VariationOnSale ? Math.ceil(variationB.VariationPrice - (variationB.VariationPrice * b.Sale / 100)) : variationB.VariationPrice;
          }
          else {
            priceB = b.IsOnSaleChecked && b.Sale > 0 && (b.SaleEnd == null || new Date(b.SaleEnd) > new Date()) ? Math.ceil(b.Price - (b.Price * b.Sale / 100)) : b.Price;
          }

          return parseFloat(priceB) - parseFloat(priceA);
        });
        break;
      case "TitleAToZ":
        this.shoppingCartObj.shoppingCartWishlistProducts.sort((a, b) => a.Title.localeCompare(b.Title));
        break;
      case "TitleZToA":
        this.shoppingCartObj.shoppingCartWishlistProducts.sort((a, b) => b.Title.localeCompare(a.Title));
        break;
    }
  }


  /**
  Get the ProductID or Variation of the product in the cart
  @param productCart the product of shoppingCartObj.pointStoreCart.pointStoreProducts
  */ 
  GetProductCartId(productCart: any): number{
    let id = 0;

    //The product has variations
    if(productCart.Variation != null && productCart.Variation > 0){
      id = productCart.Variation;
    } else{
      id = productCart.ProductID;
    }
    return id;
  }

  /**
   * async function to validate the existence of the products in the cart
   */
  async checkShopingCartExistencies(){
    for (let product of this.shoppingCartObj.pointStoreProducts) {
      for (let productCart of this.shoppingCartObj.pointStoreCart.pointStoreProducts) {
        if (product.PointStoreProductID == productCart.ProductID) {
          let response: any = await this.checkProductExistenciesWS(productCart, false, 0);
          let productID = this.GetProductCartId(productCart);
          if (response) {
            this.shoppingCartObj.pointStoreProductValidation[productID] = false;
          } else {
            this.shoppingCartObj.pointStoreProductValidation[productID] = true;
          }
        }
      }
    }
  }
}
